import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppComponent } from '../../app.component';

@Component({
	selector: 'app-short-info-modal',
	templateUrl: './short-info-modal.component.html',
	styleUrls: ['short-info-modal.component.scss'],
})
export class ShortInfoModalComponent {
	desc: string;

	constructor(private modalCtrl: ModalController) {}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
